import { render } from "./OnboardingWelcome.vue?vue&type=template&id=53c40216&scoped=true"
import script from "./OnboardingWelcome.vue?vue&type=script&lang=js"
export * from "./OnboardingWelcome.vue?vue&type=script&lang=js"

import "./OnboardingWelcome.vue?vue&type=style&index=0&id=53c40216&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c40216"]])

export default __exports__